var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodepen = function SvgCodepen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 4 4 17.344v15.308L25 46l21-13.344V17.344Zm0 25.184-5.934-4.114L25 21.023l5.934 4.047Zm2-11.579V9.95l13.43 8.535-6.02 4.172Zm-4 0-7.41 5.051-6.02-4.172L23 9.95Zm-10.906 7.438L8 27.832v-5.629Zm3.476 2.41L23 32.605v7.446L9.59 31.527ZM27 32.605l7.43-5.152 5.98 4.074L27 40.051Zm10.906-7.562L42 22.203v5.629Z"
  })));
};
export default SvgCodepen;